import Layout from './layout';
import Sider from './sider';
import Header from './header';
import Content from './content';
import Footer from './footer';

Layout.Sider = Sider
Layout.Header = Header
Layout.Content = Content
Layout.Footer = Footer


export default Layout;
